<script setup lang="ts">
import { VContentGridItem } from '@/shared/ui'
import './assets/style.scss'
import { WCabinetControlPanel } from '@/widgets'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

defineOptions({ name: 'control' })

const route = useRoute()
const objectId = computed(() => Number(route.params.object_id))
</script>

<template>
  <VContentGridItem :title="$t('itf.control')" compact>
    <WCabinetControlPanel :objectId />
  </VContentGridItem>
</template>
